<section
  *ngIf="certificate || certificateFilePath || uncertaintyReportFilePath"
  class="certificate-result-card"
  aria-labelledby="certificate-result-title">
  <header class="certificate-result-card__header">
    <div>
      <h2 id="certificate-result-title">جزئیات کامل گواهی</h2>
      <p>اطلاعات محاسباتی و نتیجه نهایی گواهی</p>
    </div>

    <button
      *ngIf="certificateFilePath"
      type="button"
      class="btn btn-primary certificate-download-button"
      [disabled]="isDownloading"
      aria-label="دانلود فایل Word گواهی"
      (click)="download.emit()">
      <i class="fa" [ngClass]="isDownloading ? 'fa-spin fa-spinner' : 'fa-file-word-o'"></i>
      {{ isDownloading ? 'در حال دریافت فایل...' : 'دانلود فایل Word گواهی' }}
    </button>
    <button
      *ngIf="uncertaintyReportFilePath"
      type="button"
      class="btn btn-primary certificate-download-button"
      [disabled]="isDownloadingUncertaintyReport"
      aria-label="دانلود گزارش عدم قطعیت"
      (click)="downloadUncertaintyReport.emit()">
      <i class="fa" [ngClass]="isDownloadingUncertaintyReport ? 'fa-spin fa-spinner' : 'fa-file-word-o'"></i>
      {{ isDownloadingUncertaintyReport ? 'در حال دریافت فایل...' : 'دانلود گزارش عدم قطعیت' }}
    </button>
  </header>

  <ng-container *ngIf="certificate as cert; else certificateFileOnly">
    <div class="certificate-summary-grid" aria-label="اطلاعات کلی گواهی">
      <div class="certificate-summary-item"><span>نام گواهی</span><strong>{{ formatCertificateValue(cert.name) }}</strong></div>
      <div class="certificate-summary-item"><span>شرح گواهی</span><strong>{{ formatCertificateValue(cert.description) }}</strong></div>
      <div class="certificate-summary-item"><span>تعداد فرمول‌ها</span><strong>{{ cert.formulas.length }}</strong></div>
      <div class="certificate-summary-item"><span>وضعیت فایل Word</span><strong>{{ certificateFilePath ? 'فایل گواهی آماده دانلود است' : 'فایل گواهی هنوز ایجاد نشده است' }}</strong></div>
    </div>

    <p class="certificate-empty-message" *ngIf="cert.formulas.length === 0">نتیجه محاسباتی برای نمایش وجود ندارد.</p>

    <app-data-entity-volume-certificate-formula
      *ngFor="let formula of cert.formulas; let formulaIndex = index; trackBy: trackByFormula"
      [formula]="formula"
      [formulaIndex]="formulaIndex"
      [initiallyExpanded]="formulaIndex === 0">
    </app-data-entity-volume-certificate-formula>

    <section class="certificate-section certificate-regression-section" *ngIf="hasRegression(cert.regression); else missingCertificateRegression">
      <h3>رگرسیون کلی گواهی</h3>
      <ng-container *ngTemplateOutlet="regressionDetails; context: { $implicit: cert.regression }"></ng-container>
    </section>
    <ng-template #missingCertificateRegression><p class="certificate-empty-message">اطلاعات رگرسیون موجود نیست.</p></ng-template>
  </ng-container>

  <ng-template #certificateFileOnly>
    <div class="certificate-file-only">
      <strong>فایل گواهی آماده دانلود است.</strong>
      <span>جزئیات محاسباتی گواهی در پاسخ موجود نیست.</span>
    </div>
  </ng-template>
</section>

<ng-template #regressionDetails let-regression>
  <div class="certificate-detail-grid">
    <div><span>کمیت‌ها</span><strong>{{ regression.quantities.length ? regression.quantities.join('، ') : '—' }}</strong></div>
    <div><span>عدم قطعیت‌های گسترده</span><strong>{{ regression.expandedUncertainies.length ? regression.expandedUncertainies.join('، ') : '—' }}</strong></div>
    <div><span>شیب</span><strong>{{ formatCertificateValue(regression.slope) }}</strong></div>
    <div><span>عرض از مبدأ</span><strong>{{ formatCertificateValue(regression.intercept) }}</strong></div>
    <div><span>ضریب همبستگی</span><strong>{{ formatCertificateValue(regression.correlation) }}</strong></div>
    <div><span>B Prime</span><strong>{{ formatCertificateValue(regression.bPrime) }}</strong></div>
  </div>
  <div class="certificate-code-group" *ngIf="regression.equation"><span>معادله</span><pre dir="ltr" class="certificate-formula-code">{{ regression.equation }}</pre></div>
  <div class="certificate-code-group" *ngIf="regression.uncertaintyEquation"><span>معادله عدم قطعیت</span><pre dir="ltr" class="certificate-formula-code">{{ regression.uncertaintyEquation }}</pre></div>
</ng-template>
